<template>
  <div class="d-flex align-center">
    <div :class="{redPoint: required, transparentPoint: !required }"></div>
    <v-menu v-model="showMenu" :close-on-content-click="false" offset-y open-delay>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="d-flex selector-btn px-4 align-center ml-5">
          <div
            class="normal-text textcolor9--text"
            v-if="value == null"
          >{{ $t('album.sheet.composer')}}</div>
          <div class="normal-text" v-if="value != null">{{ value.text }}</div>
        </div>
      </template>


        <v-list subheader max-height="200">
          <v-subheader>User Controls</v-subheader>
          <v-lazy v-for="(option, index) in options" :key="index">
            <v-list-item >
              <v-list-item-content @click="updateOption(option)">
                <v-list-item-title>{{ option.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-lazy>
        </v-list>

    </v-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: {
        name: ""
      },
      showMenu: false,
      placeholderText: "Please select an item"
    };
  },
  props: {
    options: {
      type: [Array, Object]
    },
    value: Object,
    reminding: Boolean,
    placeholder: [String],
    closeOnOutsideClick: {
      type: [Boolean],
      default: true
    },
    required: {
      type: [Boolean],
      default: false
    }
  },

  beforeDestroy() {
    document.removeEventListener("click", this.clickHandler);
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.value = this.selectedOption;
      this.$emit("input", this.selectedOption);
    }
  }
};
</script>

<style scoped>
.redPoint {
  background-color: #e62e2e;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}

.transparentPoint {
  background-color: transparent;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}

.selector-btn {
  height: 62px;
  cursor: pointer;
  width: 100%;
  background-color: #f9fafc;
  border-width: 1px;
  border-color: #e3e3e3;
  border-style: solid;
}

.normal-text {
  font-size: 14px;
}
</style>
